import {
  UPDATE_PLC_SAFETY_TRIGGER,
  UPDATE_PLC_SAFETY_TRIGGER_SUCCESSFUL,
  UPDATE_PLC_SAFETY_TRIGGER_FAILED,
} from './actionTypes';

export const updatePlcSafetyTrigger = (trigger) => ({
  type: UPDATE_PLC_SAFETY_TRIGGER,
  payload: { trigger },
});

export const updatePlcSafetyTriggerSuccessful = (message) => ({
  type: UPDATE_PLC_SAFETY_TRIGGER_SUCCESSFUL,
  payload: message,
});

export const updatePlcSafetyTriggerFailed = (message) => ({
  type: UPDATE_PLC_SAFETY_TRIGGER_FAILED,
  payload: message,
});
